export default "__VITE_ASSET__C0Xqm_vD__"